import { ChangeDetectionStrategy, Component, ElementRef, input, output, viewChild } from '@angular/core';

/** Presentational search box for the variable picker: magnifier, input, match-count badge, clear. */
@Component({
  selector: 'app-variable-picker-search',
  templateUrl: './variable-picker-search.component.html',
  styleUrl: './variable-picker-search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VariablePickerSearchComponent {
  public readonly query = input('');
  /** Live match count; shown only when `active` is true. */
  public readonly count = input<number | null>(null);
  public readonly active = input(false);
  public readonly placeholder = input('Filter variables…');

  public readonly queryChange = output<string>();
  public readonly cleared = output<void>();

  private readonly inputEl = viewChild.required<ElementRef<HTMLInputElement>>('queryInput');

  protected onInput(event: Event): void {
    this.queryChange.emit((event.target as HTMLInputElement).value);
  }

  protected clear(): void {
    this.cleared.emit();
    this.inputEl().nativeElement.focus();
  }
}
